import { useEffect, useState } from 'react';
import { ButtonVariants } from '../Atoms/Button';
import { StickyCTA } from '../CTA/StickyCTA';
import { ButtonWithAnchor } from '../income-tax/page-sections/hero-section/sticky-button';
import { startFilingLink } from '../income-tax/static/data';
import { addCommasToNumber } from '../Utils/CommonUtils';
import { TAX_RESULT } from './types';
interface TaxLiabilityCardProps {
  taxData: TAX_RESULT | null;
}

const TaxLiabilityCard = ({ taxData }: TaxLiabilityCardProps) => {
  const oldTax = Number(taxData?.newBudgetOldRegime?.grossTax || 0);
  const newTax = Number(taxData?.newBudgetNewRegime?.grossTax || 0);
  const hasValidTaxData = taxData && (oldTax > 0 || newTax > 0);
  const [isMobile, setIsMobile] = useState(false);
  let recommendedRegime: 'old' | 'new' | null = null;
  if (hasValidTaxData) {
    if (oldTax < newTax) recommendedRegime = 'old';
    else if (newTax < oldTax) recommendedRegime = 'new';
  }
  useEffect(() => {
    const checkIsMobile = () => setIsMobile(window.innerWidth < 640);
    checkIsMobile();
    window.addEventListener('resize', checkIsMobile);
    return () => window.removeEventListener('resize', checkIsMobile);
  }, []);
  return (
    <>
      <div
        className={`flex flex-col items-center bg-white p-6 rounded-lg shadow-lg w-full sm:bg-white  sm:p-4 sm:w-full sm:z-100 sm:hidden ${
          !hasValidTaxData ? 'sm:hidden' : ''
        }`}
        style={{ boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)' }}
      >
        <p className="text-xl font-semibold text-gray-800 mb-4 text-center">
          Tax Liability Summary
        </p>
        <div className="sm:w-full sm:flex sm:pb-10 ">
          <div className="mb-2 text-center w-full sm:flex sm:flex-col sm:items-center sm:justify-center">
            <div className="text-base text-gray-600 sm:flex items-center justify-center space-x-2 ">
              <span>Old Regime</span>
              {recommendedRegime === 'old' && (
                <span
                  className="text-s-10 text-green-600 font-semibold bg-green-100 px-2 py-0.5 rounded whitespace-nowrap ml-2 "
                  style={{
                    position: 'absolute',
                    transform: isMobile
                      ? 'translate(-3px, -50%)'
                      : 'translate(8px, -50%)',
                    marginTop: isMobile ? '-19px' : '12px',
                  }}
                >
                  Recommended
                </span>
              )}
            </div>
            <div
              className={`text-s-18 font-bold sm:flex-row ${
                taxData && oldTax < newTax ? 'text-blue-600' : 'text-gray-800'
              }`}
            >
              ₹{addCommasToNumber(taxData?.newBudgetOldRegime?.grossTax) || 0}
            </div>
          </div>
          <p className="text-s-14 text-gray-600 mb-2 text-center w-full sm:hidden">
            vs
          </p>
          <div className="mb-4 text-center w-full sm:flex sm:flex-col sm:items-center sm:justify-center ">
            <div className="text-base text-gray-600 sm:flex items-center justify-center space-x-2 ">
              <span>New Regime</span>
              {recommendedRegime === 'new' && (
                <span
                  className="text-s-10 text-green-600 font-semibold bg-green-100 px-2 py-0.5 rounded whitespace-nowrap ml-2 sm:mt-2"
                  style={{
                    position: 'absolute',
                    transform: isMobile
                      ? 'translate(-3px, -50%)'
                      : 'translate(8px, -50%)',
                    marginTop: isMobile ? '-19px' : '12px',
                  }}
                >
                  Recommended
                </span>
              )}
            </div>
            <div
              className={`text-s-18 font-bold ${
                taxData && newTax < oldTax ? 'text-blue-600' : 'text-gray-800'
              }`}
            >
              ₹{addCommasToNumber(taxData?.newBudgetNewRegime?.grossTax) || 0}
            </div>
          </div>
        </div>
        <div className="mb-3 text-center w-full bg-green-50 p-4 rounded-md sm:hidden">
          <p className="text-base text-green-600">You save</p>
          <p className="text-s-18 font-bold text-green-600">
            ₹{taxData ? addCommasToNumber(Math.abs(oldTax - newTax)) : 0}
          </p>
        </div>
        <ButtonWithAnchor
          trackLabel="tax-liability-card-file-now"
          buttonVariant={ButtonVariants.bluefilled}
          className="text-base font-medium w-full py-3 rounded sm:hidden"
          buttonLink={startFilingLink}
          buttonText="File Now"
        />
      </div>
      <StickyCTA
        buttonText="File Now"
        buttonStyle={ButtonVariants.bluefilled}
        alwaysVisible={true}
      />
    </>
  );
};

export default TaxLiabilityCard;
